var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6052 11.4645C20.4587 9.99365 16.8948 6 11.9997 6C7.10461 6 3.54074 9.99365 2.39415 11.4645C2.14596 11.7829 2.14596 12.2171 2.39415 12.5355C3.54074 14.0063 7.10461 18 11.9997 18C16.8948 18 20.4587 14.0063 21.6052 12.5355C21.8534 12.2171 21.8534 11.7829 21.6052 11.4645ZM20.5497 12C20.5497 12 17.1297 7.2 11.9997 7.2C6.8697 7.2 3.4497 12 3.4497 12C3.4497 12 6.8697 16.8 11.9997 16.8C17.1297 16.8 20.5497 12 20.5497 12ZM11.9997 15.5C13.9327 15.5 15.4997 13.933 15.4997 12C15.4997 10.067 13.9327 8.5 11.9997 8.5C10.0667 8.5 8.4997 10.067 8.4997 12C8.4997 13.933 10.0667 15.5 11.9997 15.5ZM14.2997 12C14.2997 13.2703 13.27 14.3 11.9997 14.3C10.7294 14.3 9.6997 13.2703 9.6997 12C9.6997 10.7297 10.7294 9.7 11.9997 9.7C13.27 9.7 14.2997 10.7297 14.2997 12Z",
    fill: "#CDCDCD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.a895be10.svg";
export { ForwardRef as ReactComponent };